import { z } from 'zod';
import { requiredClientGeneratedUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { shipShortfallChoiceInputSchema } from './ship-shortfall-choice-input.js';
import { uniqueLineList } from './unique-line-list.js';
// The choices go with one key, so a retried Ship confirm writes and ships once (S-5); Mark Delivered records the capture.
export const completeSalesOrderShipmentInputSchema = z.object({
    salesOrderId: requiredUuidString('Sales order is required.', 'Invalid sales order selection.'),
    shipId: requiredUuidString('Shipment is required.', 'Invalid shipment selection.'),
    shortfallChoices: uniqueLineList(shipShortfallChoiceInputSchema),
    idempotencyKey: requiredClientGeneratedUuidString('Ship confirmation key is required.', 'Invalid ship confirmation key.'),
});
//# sourceMappingURL=complete-shipment-input.js.map